import { render, staticRenderFns } from "./DetailedLotInspection.vue?vue&type=template&id=45b3b6dd"
import script from "./DetailedLotInspection.vue?vue&type=script&lang=js"
export * from "./DetailedLotInspection.vue?vue&type=script&lang=js"
import style0 from "./DetailedLotInspection.vue?vue&type=style&index=0&id=45b3b6dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports